import React, { useState } from "react";
import { BrowserRouter, Route, Link } from "react-router-dom";

function Navbar4() {

  const [teetimeVisible, setTeeTimeVisible] = useState(false);

  const playClick = () => {
    setTeeTimeVisible(!teetimeVisible);
    console.log(teetimeVisible);
  }

    const PlayMenu = () => {
    return(
      <div>
        <ul>
          <li>
            <a class="coursesNav" href="/westfield/play">Daily Play</a>
          </li>
          <li>
            <a class="coursesNav" href="/westfield/stayplay">Stay & Play</a>
          </li>
        </ul>
      </div>
    )
  }

  return (
    <nav class="westfieldNav">
      <ul>
        <li>
          <a href="/westfield">
            <div class="westfieldNavLogo"></div>
          </a>
        </li>
        <li class="coursesLi">
            <div class="dropdownMenu westfieldDropdown">
                <a onClick={playClick}>Play</a>
                {teetimeVisible && <PlayMenu />}
            </div>
        </li>
        <li>
            <a href="/westfield/courses">Courses</a>
        </li>
        <li>
          <a href="/westfield/reviews">
            Reviews
          </a>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar4;